import { createFileRoute } from '@tanstack/react-router'
import {
  ADMIN_SONG_FILTER_KEYS,
  ADMIN_SONG_SORT_IDS,
} from '@/features/songs/components/songs/admin-songs-columns'
import { AdminSongsPage } from '@/features/songs/pages/admin-songs-page'
import { createTableSearchSchema } from '@/lib/data-table/search-schema'

const songsSearchSchema = createTableSearchSchema({
  defaultPageSize: 20,
  sortIds: ADMIN_SONG_SORT_IDS,
  filterKeys: ADMIN_SONG_FILTER_KEYS,
})

export const Route = createFileRoute('/songs')({
  staticData: { title: 'Songs' },
  validateSearch: songsSearchSchema,
  component: AdminSongsPage,
})
